import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Select } from 'antd';
import { send_sms_options, send_sms_options_with_confirm } from '../statics';

const mapStateToProps = state => ({
    root_id: state.Leads.Lead_profile.Lead_general.root_id,
    current_status: state.Leads.Lead_profile.Lead_general.current_status,
}); const { Option } = Select; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class SendSMSModal extends PureComponent {
  state = {
      value: '',
      key: 0,
  };

  handleChange = (value, key) => this.setState({ value, key: key.key });

  sendSMS = () => {
      this.props.dispatch({ type: 'SEND_SMS_REQUEST', template_id: +this.state.key, lead_id: this.props.root_id });
      this.props.closeModal();
  };

  render() {
      return (
          <Form>
              <FormItem label="Please choose which type of message send to this customer">
                  <Select
                      showSearch
                      placeholder="SMS"
                      notFoundContent="SMS not Found"
                      value={this.state.value}
                      onChange={this.handleChange}
                  >
                      <Option value="" style={{ color: 'lightgray' }} disabled>Select Option</Option>
                      {(this.props.current_status.name === 'Arrange Collection' || this.props.current_status.name === 'Transport Arranged')
                          ? send_sms_options_with_confirm.map(value => <Option value={value.value} key={value.template_id}>{value.value}</Option>)
                          : send_sms_options.map(value => <Option value={value.value} key={value.template_id}>{value.value}</Option>)}
                  </Select>
              </FormItem>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button onClick={this.props.closeModal}>Cancel</Button>
                  <Button style={{ marginLeft: 10 }} disabled={!this.state.value} type="primary" onClick={this.sendSMS}>Send</Button>
              </div>
          </Form>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/SendSMSModal.js